"use client"

import dynamic from "next/dynamic"
import type { ComponentProps } from "react"

// next/dynamic only splits in a client module: called from a server component
// every client module in its import graph lands in the route's first load.
const Lazy = dynamic(() =>
  import("./test-detail-client").then((m) => m.TestDetailClient)
)

export function TestDetailClientLazy(props: ComponentProps<typeof Lazy>) {
  return <Lazy {...props} />
}
